import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// localStorage key for the auth fallback token. The cookie remains the primary
// credential; this Bearer token only kicks in when the cookie is missing —
// notably on iOS PWA standalone mode, where the OAuth redirect can land in a
// different cookie storage partition than the home-screen launched PWA.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const SESSION_TOKEN_KEY = "fc-session-token";

export function getStoredSessionToken() {
  try {
    return localStorage.getItem(SESSION_TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

export function setStoredSessionToken(token) {
  try {
    if (token) localStorage.setItem(SESSION_TOKEN_KEY, token);
    else localStorage.removeItem(SESSION_TOKEN_KEY);
  } catch {
    /* private mode / disabled storage — silently degrade */
  }
}

export function clearStoredSessionToken() {
  setStoredSessionToken(null);
}

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach Bearer fallback whenever a token is stored locally.
api.interceptors.request.use((config) => {
  const token = getStoredSessionToken();
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Drop the stored fallback on auth failures so we don't loop with a stale token.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearStoredSessionToken();
    }
    return Promise.reject(err);
  }
);
